import React,{ useState } from "react"
import {TestCodeSearchForm} from "./TestCodeSearchForm"
import {ApiLogin} from "../../types/types"
import {TestCodeManagementTable} from "./TestCodeManagementTable"
import lodash from "lodash"
import {MessageView} from "../common/messages/MessageView"
import TestCodeManagementApiService from "./TestCodeManagementService"

export interface UpdateTestCodesDTO {
    loginId: number
    isHandwritten: boolean
}

export const TestCodeManagement = () => {
    const [searchString, setSearchString] = useState("")
    const [loginsFromApi, setLoginsFromApi] = useState<ApiLogin[]>([])

    const onSearchLoginsByUsername = async (username: string) => {
        const logins: ApiLogin[] = await TestCodeManagementApiService.searchTestCodesContaining(username)
        setLoginsFromApi(lodash.orderBy(logins, "username", "asc"))
    }

    const onSearch = () => onSearchLoginsByUsername(searchString)

    return (
        <>
            <TestCodeSearchForm
                setSearchString={setSearchString}
                testCodeSearchString={searchString}
                onSearch={onSearch}
            />
            <TestCodeManagementTable
                testCodeData={loginsFromApi}
                setTestCodeData={setLoginsFromApi}
                onSearch={onSearch}
            />
            <MessageView />
        </>
    )
}
